var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranslations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.875H7.5V5.625H14.25V4.875Z",
    fill: "url(#paint0_linear_1204_20884)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.375H4.875V7.125H16.875V6.375Z",
    fill: "url(#paint1_linear_1204_20884)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 7.875H12.75V8.625H16.875V7.875Z",
    fill: "url(#paint2_linear_1204_20884)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.875H4.875V8.625H12V7.875Z",
    fill: "url(#paint3_linear_1204_20884)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 9.375H4.875V10.125H7.875V9.375Z",
    fill: "url(#paint4_linear_1204_20884)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 9.375H8.625V10.125H16.875V9.375Z",
    fill: "url(#paint5_linear_1204_20884)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.125H10.5V16.875H9V17.625H9.45234C9.63446 18.33 9.95153 18.993 10.386 19.5773C10.2336 19.738 10.0704 19.8882 9.89758 20.0267L9.51572 20.3322L9.98428 20.9178L10.3661 20.6123C10.545 20.4688 10.715 20.3144 10.875 20.15C11.035 20.3144 11.2049 20.4688 11.3839 20.6123L11.7657 20.9178L12.2343 20.3322L11.8524 20.0267C11.6795 19.8882 11.5164 19.738 11.364 19.5773C11.7985 18.993 12.1155 18.33 12.2977 17.625H12.75V16.875H11.25V16.125ZM11.5194 17.625C11.3749 18.1042 11.1575 18.5583 10.875 18.9714C10.5925 18.5583 10.3751 18.1042 10.2306 17.625H11.5194ZM10.5268 11.8607L9.02682 15.6107L9.72318 15.8893L10.0789 15H11.6711L12.0268 15.8893L12.7232 15.6107L11.2232 11.8607C11.1953 11.7912 11.1473 11.7315 11.0852 11.6895C11.0232 11.6475 10.9499 11.625 10.875 11.625C10.8001 11.625 10.7268 11.6475 10.6648 11.6895C10.6027 11.7315 10.5547 11.7912 10.5268 11.8607ZM11.3711 14.25H10.3789L10.875 13.0097L11.3711 14.25ZM13.97 12.5831L15.2492 12.3699L15.1258 11.6301L12.8758 12.0051C12.8224 12.014 12.7715 12.0344 12.7267 12.0649C12.6819 12.0953 12.6442 12.1352 12.6162 12.1816C12.5883 12.228 12.5707 12.28 12.5648 12.3338C12.5588 12.3877 12.5646 12.4422 12.5817 12.4936L13.3317 14.7436L14.0433 14.5064L13.6349 13.2814C14.0616 13.6518 14.4041 14.1092 14.6396 14.6229C14.875 15.1366 14.9979 15.6946 15 16.2597C15.0023 16.9346 14.8301 17.5986 14.5001 18.1873C14.1701 18.7761 13.6935 19.2695 13.1166 19.6197L13.5084 20.2592C14.1528 19.8654 14.6925 19.3217 15.0816 18.6744C15.4706 18.0272 15.6975 17.2954 15.7428 16.5416C15.7881 15.7878 15.6506 15.0341 15.3419 14.3449C15.0333 13.6557 14.5626 13.0512 13.97 12.5831Z",
    fill: "url(#paint6_linear_1204_20884)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24592 17.5628L7.50608 17.6861L7.70583 18.8844C7.08704 18.1705 6.74783 17.2567 6.751 16.3119C6.75317 15.5084 7.00007 14.7246 7.45882 14.0648C7.91758 13.4051 8.56643 12.9008 9.31896 12.619L9.05804 11.9159C8.1622 12.2513 7.38979 12.8516 6.84366 13.637C6.29753 14.4223 6.0036 15.3554 6.001 16.3119C5.99889 16.9306 6.12025 17.5436 6.35799 18.1148C6.59572 18.686 6.94504 19.204 7.38549 19.6385L5.93934 19.8795L6.06266 20.6194L8.31266 20.2444C8.41076 20.228 8.49835 20.1733 8.55616 20.0924C8.61397 20.0115 8.63726 19.9109 8.62092 19.8128L8.24592 17.5628Z",
    fill: "url(#paint7_linear_1204_20884)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1498 4.57677C23.0581 4.37403 22.9084 4.20304 22.7195 4.08542C22.5306 3.9678 22.3111 3.90883 22.0887 3.91596C21.8663 3.92309 21.651 3.99602 21.4701 4.1255C21.2892 4.25499 21.1507 4.43522 21.0721 4.64342L21 4.83472V1.125C21 1.02555 20.9605 0.930165 20.8902 0.85984C20.8198 0.789515 20.7245 0.750005 20.625 0.75H5.625C5.52555 0.750005 5.43017 0.789515 5.35984 0.85984C5.28952 0.930165 5.25001 1.02555 5.25 1.125V3H3.375C3.27555 3.00001 3.18017 3.03952 3.10984 3.10984C3.03952 3.18017 3 3.27555 3 3.375V22.875C3 22.9745 3.03952 23.0698 3.10984 23.1402C3.18017 23.2105 3.27555 23.25 3.375 23.25H15.0644C15.2122 23.2504 15.3586 23.2215 15.4951 23.1649C15.6317 23.1084 15.7556 23.0253 15.8599 22.9205L17.7804 21H20.625C20.7245 21 20.8198 20.9605 20.8902 20.8902C20.9605 20.8198 21 20.7245 21 20.625V11.2114L23.1774 5.43736C23.23 5.29921 23.2546 5.15202 23.2498 5.0043C23.2451 4.85658 23.2111 4.71127 23.1498 4.57677ZM6 1.5H20.25V6.82352L18.75 10.8011V3.375C18.75 3.27555 18.7105 3.18017 18.6402 3.10984C18.5698 3.03952 18.4745 3.00001 18.375 3H6V1.5ZM15.75 21.9696V20.25H17.4696L15.75 21.9696ZM18 19.5H15.375C15.2755 19.5 15.1802 19.5395 15.1098 19.6098C15.0395 19.6802 15 19.7755 15 19.875V22.5H3.75V3.75H18V12.7899L16.5732 16.5733C16.5527 16.6278 16.5451 16.6863 16.5511 16.7442L16.7236 18.4124C16.7307 18.4817 16.7571 18.5476 16.7996 18.6027C16.8421 18.6579 16.8991 18.7001 16.9643 18.7247C17.0294 18.7493 17.1002 18.7552 17.1685 18.7418C17.2369 18.7285 17.3001 18.6964 17.3513 18.6491L18 18.0489V19.5ZM20.25 20.25H18.5168C18.6685 20.0537 18.7506 19.8125 18.75 19.5644V17.1778L20.25 13.2002V20.25ZM18.008 17.0198L17.3925 17.5892L17.3062 16.7551L21.1123 6.66246L21.8141 6.92713L18.008 17.0198ZM22.4757 5.17268L22.0787 6.22537L21.3769 5.9607L21.7739 4.9081C21.7912 4.86198 21.8175 4.81974 21.8512 4.78378C21.8849 4.74782 21.9253 4.71885 21.9702 4.69853C22.0151 4.6782 22.0635 4.66692 22.1128 4.66533C22.162 4.66374 22.2111 4.67186 22.2572 4.68924C22.3033 4.70663 22.3455 4.73292 22.3814 4.76663C22.4174 4.80033 22.4463 4.84079 22.4666 4.88569C22.4869 4.93058 22.4981 4.97904 22.4997 5.02828C22.5013 5.07753 22.4931 5.1266 22.4757 5.17268Z",
    fill: "url(#paint8_linear_1204_20884)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1204_20884",
    x1: 22.6905,
    y1: -5.39826,
    x2: -0.781758,
    y2: -3.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01031D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslations);
export default __webpack_public_path__ + "static/media/Translations.c7a2eabe35eea416f092bdb52657601a.svg";
export { ForwardRef as ReactComponent };